import {Injectable, TemplateRef} from '@angular/core';
import {WindowRef, WindowService} from '@progress/kendo-angular-dialog';
import {Observable} from 'rxjs';

/**
 ****************************************************************
 * Popup window service.
 *
 * Created by Shai Zelman on 17/04/2020.
 ****************************************************************
 */
@Injectable({
  providedIn: 'root'
})
export class PopupWindowService {
	public anyPopupsOpen: boolean = false;

  private windowRefs: WindowRef[] = [];

	constructor(private windowService: WindowService) {}

	public openPopupWindow(popupContent: string | TemplateRef<any> | Function, titleTemplate: TemplateRef<any>, width: number = null,
                         height: number = null, left: number = null, top: number = null, params: { [p: string]: any; } = null): Observable<any> {
    let windowRef: WindowRef = this.windowService.open({
      title: 'Test',
      content: popupContent,
      draggable: false,
      resizable: false,
      titleBarContent: titleTemplate,
      width: width,
      height: height,
      left: left,
      top: top
    });

    if (params) {
      const instance = windowRef.content.instance;
      Object.keys(params).forEach(p => instance[p] = params[p]);
    }

    this.windowRefs.push(windowRef);

    this.anyPopupsOpen = true;

    windowRef.window.onDestroy(() => {
      if (this.windowRefs.includes(windowRef)) {
        this.windowRefs.splice(this.windowRefs.findIndex((entry) => entry === windowRef));

        this.anyPopupsOpen = this.windowRefs.length > 0;
      }
    });

    return windowRef.result;
  }

  public closeAllPopups(): void {
	  this.windowRefs.forEach((windowRef: WindowRef) => windowRef.close());
	  this.windowRefs = [];
    this.anyPopupsOpen = false;
  }

  public closePopup(windowRef: WindowRef, arg?: any): void {
	  windowRef.close(arg);
    this.windowRefs.splice(this.windowRefs.findIndex((entry) => entry === windowRef));

    this.anyPopupsOpen = this.windowRefs.length > 0;
  }

  public closeLatestPopup(arg?: any): void {
	  if (this.windowRefs.length > 0) {
	    this.windowRefs.pop().close(arg)
    }

    this.anyPopupsOpen = this.windowRefs.length > 0;
  }
}
